import { Button, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import Label from "../../../components/label";
import Iconify from "../../../components/iconify";
import { useBoolean } from "../../../hooks/use-boolean";
import { ConfirmDialog } from "../../../components/custom-dialog";
import { IBranch } from "../../../types/branch";

type Props = {
    row: IBranch;
    onDeleteRow: (id: number) => void;
    onEditRow: VoidFunction;
}


const BranchTableRowComponent = ({ row, onDeleteRow, onEditRow } : Props) => {
  
    const confirm = useBoolean();

    return (
        <>
            <TableRow hover>

                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.id}</TableCell>                

                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.code}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.name}</TableCell>

                <TableCell>
                    <Label
                        variant="soft"
                        color={row.deletedAt ? 'error' : 'success'}
                    >
                        {row.deletedAt ? 'Não' : 'Sim'}
                    </Label>
                </TableCell>

                <TableCell align="right">
                    <Tooltip title="Editar" placement="top" arrow>
                        <IconButton color="default" onClick={onEditRow}>
                            <Iconify icon="solar:pen-bold" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={row.deletedAt ? 'Ativar' : 'Desativar'} placement="top" arrow>
                        <IconButton color="error" onClick={confirm.onTrue}>
                            <Iconify icon={row.deletedAt ? 'octicon:upload-16' : 'solar:trash-bin-trash-bold'} />
                        </IconButton>
                    </Tooltip>
                </TableCell>

            </TableRow>

            <ConfirmDialog
                open={confirm.value}
                onClose={confirm.onFalse}
                title={row.deletedAt ? 'Ativar' : 'Desativar' + ' Filial'}
                content={`Você tem certeza que deseja ${row.deletedAt ? 'ativar' : 'desativar'} esta filial?`}
                action={
                    <Button variant="contained" color="error" onClick={() => onDeleteRow(row.id)}>
                        {row.deletedAt ? 'Ativar' : 'Desativar'}
                    </Button>
                }
            />
        </>
    );

}

export default BranchTableRowComponent;